import * as metaStateUtils from '../../../store/util/metaStateUtils';


/**
 * @param state {object} Global state
 * @return {object} Domain state
 */
const getDomainState = state => {

    return state.order;
};


/**
 * @param state {object} Global state
 * @param orderId {string} Order id to get order for
 * @return {object} Order for the given id
 */
export const getOrder = (state, orderId) => {

    const domainState = getDomainState(state);

    return domainState.orders[orderId];
};


/**
 * @param state {object} Global state
 * @param orderId {string} Order id to get order for
 * @return {object} Order for the given id
 */
export const getOrderSummary = (state, orderId) => {

    const domainState = getDomainState(state);

    return domainState.orderSummaries[orderId];
};


/**
 * @param state {object} Global state
 * @param orderId {string} Order id to check for loaded state
 * @return {boolean} True if order is loaded
 */
export const isOrderLoaded = (state, orderId) => {

    const order = getOrder(state, orderId);

    return order && metaStateUtils.isLoaded(order);
};


/**
 * @param state {object} Global state
 * @param orderId {string} Order id to check for loaded state
 * @return {boolean} True if order is loaded
 */
export const isOrderSummaryLoaded = (state, orderId) => {

    const order = getOrderSummary(state, orderId);

    return order && metaStateUtils.isLoaded(order);
};



